module.exports = __webpack_public_path__ + "static/media/enrolled.9fac1167.svg";